import { API_PRICE_LABLE } from 'utils/constants'
import Api from './axiosInstance'

type FetchPriceLabelsParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export const fetchPriceLabels = ({
  limit,
  page,
  search,
  filters,
}: FetchPriceLabelsParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_PRICE_LABLE.PRICE_LABEL}?${params}`,
  })
}

export const importPriceLabelData = async (data: any) => {
  return Api.post({
    url: API_PRICE_LABLE.IMPORT,
    data: data,
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const exportPriceLabelData = async ({
  filters,
}: {
  filters: Record<string, any>
}) => {
  const params = new URLSearchParams(filters)
  return Api.get({
    url: `${API_PRICE_LABLE.EXPORT}?${params}`,
  })
}
